import moment from "moment";

export const existingCustomerResponse = {
  customerData: {
    id: 72341091,
    active: true,
    name: "AutoBot Testing",
    type: "Residential",
    address: {
      street: "105 Carpenter Drive",
      unit: null,
      city: "Sterling",
      state: "Virginia",
      zip: "20164",
      country: "US",
      latitude: 0,
      longitude: 0,
    },
    customFields: [],
    balance: 0,
    tagTypeIds: [],
    doNotMail: false,
    doNotService: false,
    createdOn: "2023-08-06T16:20:48.7373969Z",
    createdById: 1,
    modifiedOn: "2023-08-06T16:20:48.750929Z",
    mergedToId: null,
    externalData: null,
  },
  websiteUrl: "https://autobot.ai",
  phone: "999 999 9999",
  appointmentObj: {
    customerId: 72341091,
    customerName: "AutoBot Testing",
    phone: "999 999 9999",
    eventID: 555530215,
    reactivationTaskName:
      "projects/autobot-v1-356820/locations/us-central1/queues/schedulerReactivation/tasks/0142201914408430352",
  },
  addresses: [
    {
      taxZoneId: null,
      id: 72341095,
      customerId: 72341091,
      active: true,
      name: "105 Carpenter Drive Sterling Virginia 20164",
      address: {
        street: "105 Carpenter Drive",
        unit: null,
        city: "Sterling",
        state: "Virginia",
        zip: "20164",
        country: "US",
        latitude: 0,
        longitude: 0,
      },
      customFields: [],
      createdOn: "2023-08-06T16:20:48.7510272Z",
      createdById: 1,
      modifiedOn: "2023-08-06T16:20:48.7842511Z",
      mergedToId: null,
      zoneId: 48275445,
      tagTypeIds: [],
      externalData: null,
    },
    {
      taxZoneId: null,
      id: 74131239,
      customerId: 72341091,
      active: true,
      name: "AutoBot Testing",
      address: {
        street: "469 Cedar Lake Plz",
        unit: null,
        city: "Sterling",
        state: "Virginia",
        zip: "20164",
        country: "USA",
        latitude: null,
        longitude: null,
      },
      customFields: [],
      createdOn: "2023-09-29T16:46:27.9667116Z",
      createdById: 1,
      modifiedOn: "2023-09-29T16:46:29.1830129Z",
      mergedToId: null,
      zoneId: null,
      tagTypeIds: [],
      externalData: null,
    },
  ],
};

export const createCustomerResponse = {
  customerData: {
    id: "1234567890",
    name: "Test Customer",
    locations: [
      {
        id: "1234567890",
        name: "Test Customer",
        address: {
          street: "123 Test Street",
          city: "Test City",
          state: "Test State",
          zip: "12345",
        },
        contacts: [
          {
            type: "MobilePhone",
            value: "1234567890",
          },
          {
            type: "Email",
            value: "a@a.com",
          },
        ],
      },
    ],
  },
  websiteUrl: "https://autobot.ai",
  phone: "1234567890",
  appointmentObj: {
    customerId: "1234567890",
    customerName: "Test Customer",
    addressId: "1234567890",
    eventID: "1234567890",
    reactivationTaskName: "Test Task Name",
  },
};

export const createAddressResponse = {
  street: "1234 Massachusetts Avenue Northwest",
  unit: "",
  city: "Washington",
  state: "District of Columbia",
  zip: "20005",
  appointmentObj: {
    customerId: 72341091,
    customerName: "AutoBot Testing",
    phone: "999 999 9999",
    eventID: 722408564,
    reactivationTaskName:
      "projects/autobot-v1-356820/locations/us-central1/queues/schedulerReactivation/tasks/9100213940532331543",
  },
  websiteUrl: "https://autobot.ai",
};

export const getAvailableSlotsResponse = () => {
  const currentDate = moment();
  const todayDate = moment().format("YYYY-MM-DD");

  // Add one day to the current date
  const tomorrowDate = moment(currentDate)
    .add(1, "day")
    .format("YYYY-MM-DD");
  const dayAfterTomorrowDate = moment(currentDate)
    .add(2, "day")
    .format("YYYY-MM-DD");
  const dayThreeDate = moment(currentDate)
    .add(3, "day")
    .format("YYYY-MM-DD");
  const dayFourDate = moment(currentDate)
    .add(4, "day")
    .format("YYYY-MM-DD");
  const dayFiveDate = moment(currentDate)
    .add(5, "day")
    .format("YYYY-MM-DD");
  return {
    calendarTimes: {
      [todayDate]: [
        {
          start: "08:00:00Z",
          end: "12:00:00Z",
        },
        {
          start: "12:00:00Z",
          end: "16:00:00Z",
        },
        {
          start: "16:00:00Z",
          end: "19:00:00Z",
        },
      ],
      [tomorrowDate]: [
        {
          start: "08:00:00Z",
          end: "12:00:00Z",
        },
        {
          start: "12:00:00Z",
          end: "16:00:00Z",
        },
        {
          start: "16:00:00Z",
          end: "19:00:00Z",
        },
      ],
      [dayAfterTomorrowDate]: [
        {
          start: "08:00:00Z",
          end: "12:00:00Z",
        },
        {
          start: "12:00:00Z",
          end: "16:00:00Z",
        },
        {
          start: "16:00:00Z",
          end: "19:00:00Z",
        },
      ],
      [dayThreeDate]: [
        {
          start: "08:00:00Z",
          end: "12:00:00Z",
        },
        {
          start: "12:00:00Z",
          end: "16:00:00Z",
        },
        {
          start: "16:00:00Z",
          end: "19:00:00Z",
        },
      ],
      [dayFourDate]: [
        {
          start: "08:00:00Z",
          end: "12:00:00Z",
        },
        {
          start: "12:00:00Z",
          end: "16:00:00Z",
        },
        {
          start: "16:00:00Z",
          end: "19:00:00Z",
        },
      ],
      [dayFiveDate]: [
        {
          start: "08:00:00Z",
          end: "12:00:00Z",
        },
        {
          start: "12:00:00Z",
          end: "16:00:00Z",
        },
        {
          start: "16:00:00Z",
          end: "19:00:00Z",
        },
      ],
    },
    appointmentObj: {
      customerId: "1234567890",
      customerName: "Test Customer",
      addressId: "1234567890",
      eventID: "1234567890",
      reactivationTaskName: "Test Task Name",
      jobType: 71253663,
      businessUnit: 8071153,
    },
  };
};

export const createAppointementResponse = {};
